export default {
  regulationspolicy: {},
  selectedregulationspolicy: {},
};
